<template>
  <div>
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <page-nav-bar
      v-if="!loading && lot"
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="title">
        Passer le lot {{ lot.ref }} en vente
      </template>
    </page-nav-bar>
    <page-content
      v-if="!loading && lot"
      :has-no-padd-on-act-on-desktop="false"
      :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'">
      <div class="has-background-white is-border">
        <form
          @submit.prevent.stop="submit()"
          id="form-sale">
          <div>
            <div class="has-background-dark is-padding-left is-padding-right">
              <div class="has-text-white is-size-6 is-padding-top-xxsmall is-padding-bottom-xxsmall">
                <span class="icon is-small is-size-7 is-margin-right-xxsmall">
                  <i class="fas fa-check-circle"></i></span>
                <i>Information obligatoire pour la validation du formulaire</i>
              </div>
            </div>
            <div class="is-padding">
              <div
                class="is-margin-top"
                v-if="!seller">
                <r-label
                  :is-required="true"
                  :red-check="error.seller"
                  :value="seller"
                  :label="'Vendeur'"></r-label>
                <div class="field has-addons">
                  <div
                    v-if="sellersCount && sellersCount > 0"
                    class="control is-expanded">
                    <button
                      type="button"
                      class="button is-blocAdd is-fullwidth is-uppercase"
                      :class="isDisabled"
                      @click.prevent.stop="openSellerSelection('simple')"
                      :disabled="isDisabled">
                      <span class="vadPicto is-medium is-border is-margin-right-xsmall"><span class=""><i
                        class="fal fa-list-ul"></i></span></span>
                      <span> Vendeur interne</span>
                    </button>
                  </div>
                  <div
                    v-if="sellersExternalCount && sellersExternalCount > 0"
                    class="control is-expanded">
                    <button
                      type="button"
                      class="button is-blocAdd is-fullwidth is-uppercase"
                      :class="isDisabled"
                      @click.prevent.stop="openRelationSelection('simple')"
                      :disabled="isDisabled">
                      <span class="vadPicto is-medium is-border is-margin-right-xsmall"><span class=""><i
                        class="fal fa-list-ul"></i></span></span>
                      <span>Société</span>
                    </button>
                  </div>
                  <div class="control is-expanded">
                    <button
                      type="button"
                      class="button is-blocAdd is-fullwidth is-uppercase"
                      :class="isDisabled"
                      @click.prevent.stop="openNewUserQuickview()"
                      :disabled="isDisabled">
                      <span class="vadPicto is-medium is-border is-margin-right-xsmall"><span class=""><i
                        class="fal fa-user-plus"></i></span></span>
                      <span> Autre</span>
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="is-margin-top"
                v-else>
                <r-label
                  :is-required="true"
                  :green-check="true"
                  :label="'Affectation de la vente'"></r-label>
                <div class="columns is-gapless is-padding is-border">
                  <div class="column is-narrow">
                    <avatar :item="seller"></avatar>
                  </div>
                  <div class="column is-margin-left-small is-margin-right-small">
                    <div
                      class="title is-4"
                      v-if="seller.first_name && seller.last_name">
                      <b>{{ seller.first_name }} {{ seller.last_name }}</b>
                    </div>
                    <div
                      class="title is-4"
                      v-else-if="seller.name">
                      <b>{{ seller.name }}</b>
                    </div>
                    <div
                      class="subtitle"
                      v-if="seller.first_admin">
                      Référent : {{ seller.first_admin.name }}
                    </div>
                    <div
                      class="subtitle"
                      v-else-if="seller.profil">
                      {{ seller.profil | profilTypeLabel }}
                    </div>
                    <div
                      class="subtitle"
                      v-else-if="seller.account_name">
                      {{ seller.account_name }}
                    </div>
                    <div
                      class="subtitle"
                      v-else-if="seller.email">
                      {{ seller.email }}
                    </div>
                  </div>
                  <div class="column is-narrow has-text-right">
                    <button
                      type="button"
                      class="button is-action is-circle"
                      @click="resetSeller(); sale.buyers = null">
                      <i class="fal fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="is-margin-top">
                <r-label
                  :is-required="true"
                  :red-check="error.contact"
                  :value="contact"
                  :green-check="hasContact"
                  :label="'Contact'"></r-label>
                <div
                  v-if="seller && contactsCount !== null && contactsCount === 0"
                  class="column is-12 columns is-paddingless">
                  <div class="column is-12 is-margin-bottom-xsmall is-paddingless">
                    <div class="notification is-warning is-size-6 is-padding-top-small is-padding-bottom-small">
                      <p>Ce vendeur ne possède pas de contact actuellement.</p>
                    </div>
                  </div>
                </div>
                <div
                  class=""
                  v-if="!contact">
                  <div class="field has-addons">
                    <div
                      v-if="contactsCount && contactsCount > 0"
                      class="control is-expanded">
                      <button
                        type="button"
                        class="button is-blocAdd is-fullwidth is-uppercase"
                        :class="isDisabled"
                        @click.prevent.stop="openContactSelection('simple')"
                        :disabled="isDisabled">
                        <span class="vadPicto is-medium is-border is-margin-right-xsmall"><span class=""><i
                          class="fal fa-list-ul"></i></span></span>
                        <span> Contact existant</span>
                      </button>
                    </div>
                    <div class="control is-expanded">
                      <button
                        class="button is-blocAdd is-fullwidth is-uppercase"
                        :class="isDisabled"
                        type="button"
                        @click.prevent.stop="openNewContactQuickview()"
                        :disabled="isDisabled">
                        <span class="vadPicto is-medium is-border is-margin-right-xsmall"><span class=""><i
                          class="fal fa-user-plus"></i></span></span>
                        <span> Créer un contact</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  v-if="contact"
                  class="is-padding is-border">
                  <div class="columns is-gapless">
                    <div class="column is-narrow">
                      <avatar :item="contact"></avatar>
                    </div>
                    <div class="column">
                      <div class="is-margin-left-small is-margin-right-small">
                        <div class="title is-4">
                          <b>{{ contact.first_name }} {{ contact.last_name }}</b>
                        </div>
                        <div class="columns">
                          <div class="column is-5">
                            <span class="has-text-weight-medium is-size-7">Adresse : </span><br>
                            <span class="has-text-weight-medium is-size-7">Mail : </span><br>
                            <span class="has-text-weight-medium is-size-7">Téléphone : </span>
                          </div>
                          <div class="column is-narrow">
                            <span class="is-size-7">{{ contact.address|prettyInlineAddress }}</span><br>
                            <span class="is-size-7">{{ contact.email || 'NC' }}</span><br>
                            <phone-number
                              v-if="contact.phone"
                              :phone-class="'is-size-7'"
                              :phone="contact.phone"></phone-number>
                            <span
                              v-else
                              class="is-size-7">NC</span><br>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="column is-narrow">
                      <button
                        class="button is-action is-circle"
                        type="button"
                        @click="contact = null; sale.buyers = null">
                        <i class="fal fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns is-margin-top">
                <div class="column is-3">
                  <div class="is-margin-bottom-xsmall">
                    <r-label
                      v-if="errors.has('remuneration')"
                      :red-check="true"
                      :label="`Taux de commercialisation`"></r-label>
                    <r-label
                      v-else
                      :label="`Taux de commercialisation`"
                      :value="sale.remuneration"></r-label>
                  </div>
                  <div class="field has-addons">
                    <v-input
                      id="remuneration"
                      :name="'remuneration'"
                      :classes-input="'is-active is-input is-fullwidth'"
                      :has-incrementations="true"
                      input-type="number"
                      @input="val => sale.remuneration = Number(val)"
                      :model="sale.remuneration"
                      :has-addons="true"
                      :max="100"
                      :step="1"
                      :number="true"
                      v-validate="'required|decimal:2'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as=" ">
                      <p
                        class="control"
                        slot="addonRight">
                        <a class="button is-border is-square is-static">
                          <span class="icon"><i class="fas fa-percentage"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
                <div class="column is-3">
                  <div class="is-margin-bottom-xsmall">
                    <r-label
                      :label="'Destination'"
                      :value="sale.destination"
                      :red-check="error.destination"></r-label>
                  </div>
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select
                        class=""
                        v-model="sale.destination">
                        <option :value="null">
                          Sélectionner
                        </option>
                        <option
                          v-for="a in advDestinationsList"
                          :key="a.value"
                          :value="a.value">
                          {{ a.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <p
                    v-if="error.destination"
                    class="help is-danger">
                    Le champ est obligatoire
                  </p>
                </div>
                <div class="column is-3">
                  <div class="is-margin-bottom-xsmall">
                    <r-label
                      v-if="sale.destination === 'invest'"
                      :label="'Dispositif'"
                      :red-check="true"
                      :value="sale.tax_dispositif"></r-label>
                    <r-label
                      v-else
                      :is-required="false"
                      :label="'Dispositif'"
                      :no-check="true"
                      :value="sale.tax_dispositif"></r-label>
                  </div>
                  <div>
                    <div class="control">
                      <div class="select is-fullwidth">
                        <select
                          v-model="sale.tax_dispositif"
                          :disabled="sale.destination !== 'invest' || !availableDispositifs"
                          :class="{'is-border' : sale.destination !== 'invest' || !availableDispositifs}">
                          <option
                            :value="null"
                            selected>
                            Sélectionner
                          </option>
                          <option
                            v-for="a in availableDispositifs"
                            :key="a.value"
                            :value="a.value">
                            {{ a.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <p
                      v-if="error.tax"
                      class="help is-danger">
                      Le champ est obligatoire
                    </p>
                  </div>
                </div>
                <div class="column is-3">
                  <div class="is-margin-bottom-xsmall">
                    <r-label
                      v-if="errors.has('seller_remuneration') || error.seller_remuneration"
                      :red-check="true"
                      :label="`Rémunération vendeur`"></r-label>
                    <r-label
                      v-else
                      :label="`Rémunération vendeur`"
                      :value="sale.seller_remuneration"></r-label>
                  </div>
                  <!-- <div class="is-margin-bottom-xsmall">
                  <r-label :label="'Rémunération vendeur'" :redCheck="error.seller_remuneration" :value="sale.seller_remuneration"></r-label>
                </div> -->
                  <div class="field has-addons">
                    <v-input
                      id="seller_remuneration"
                      :name="'seller_remuneration'"
                      :classes-input="'is-active is-input is-fullwidth'"
                      :has-incrementations="true"
                      input-type="number"
                      @input="val => sale.seller_remuneration = Number(val)"
                      :model="sale.seller_remuneration"
                      :has-addons="true"
                      :max="100"
                      :step="1"
                      :number="true"
                      v-validate="'required|decimal:2'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as=" ">
                      <p
                        class="control"
                        slot="addonRight">
                        <a class="button is-border is-square is-static">
                          <span class="icon"><i class="fas fa-percentage"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
              </div>
            </div>
            <adv-lot-compact
              :lot="lot"
              :program="program"
              v-if="lot && program"
              :display-button="false" />
            <div
              v-if="lot.nature !== 'parking'"
              class="is-border-top has-background-light is-padding">
              <div class="columns is-gapless">
                <div class="column is-6">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select v-model="selectedPack">
                        <option :value="null">
                          Prix immo TTC <span v-if="sale.sale_price_ttc">- {{ sale.sale_price_ttc }} €</span>
                        </option>
                        <option
                          class="is-uppercase"
                          v-for="(pack, idx) in packList"
                          :value="pack"
                          :key="pack.name + '-' + idx">
                          {{ pack.name }} TTC <span v-if="pack.sale_price_ttc">- {{ pack.sale_price_ttc }} €</span>
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="selectedPack && selectedPack.description"
                class="has-text-black-ter">
                <b
                  class="is-size-6"
                  v-html="selectedPack.description"></b>
              </div>
              <div
                v-else-if="selectedPack && sale.pack && 'description' in sale.pack && sale.pack.description"
                class="has-text-black-ter">
                <b
                  class="is-size-6"
                  v-html="sale.pack.description"></b>
              </div>
            </div>
            <div
              v-if="selectedPack === null"
              class=" has-background-light is-padding">
              <div class="columns is-gapless">
                <div class="column">
                  <r-label
                    v-if="errors.has('sale_price_ht')"
                    :red-check="true"
                    :label="`Prix immo du lot HT`"></r-label>
                  <r-label
                    v-else
                    :label="`Prix immo du lot HT`"
                    :value="sale.sale_price_ht"></r-label>
                  <div class="field has-addons">
                    <p class="control is-expanded">
                      <v-input
                        id="sale_price_ht"
                        :name="'sale_price_ht'"
                        @input="val => updateSalePriceHt(val)"
                        :model="sale.sale_price_ht"
                        :number="true"
                        input-type="number"
                        :errors-bag="errors"
                        data-vv-value-path="val"
                        classes="has-text-right"
                        data-vv-as=" "
                        v-validate="'required|decimal:2'">
                      </v-input>
                    </p>
                    <div class="control">
                      <a class="button is-static is-border is-square"><b class="">€&nbsp;HT</b></a>
                    </div>
                  </div>
                </div>
                <div class="column is-padding-left-small is-padding-right-small">
                  <div class="field">
                    <r-label
                      :label="'Tva'"
                      :value="sale.tva"></r-label>
                    <div class="control">
                      <div class="select">
                        <select
                          class="has-text-weight-medium"
                          v-model.number="sale.tva"
                          @change="updateTva(sale.tva, sale.sale_price_ttc, null)">
                          <option :value="initialTva">
                            {{ initialTva }}%
                          </option>
                          <option :value="20.0">
                            20.0%
                          </option>
                          <option :value="10.0">
                            10.0%
                          </option>
                          <option :value="7.0">
                            7.0%
                          </option>
                          <option :value="5.5">
                            5.5%
                          </option>
                          <option :value="0">
                            0%
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div
                    class="has-text-weight-light has-text-black-ter is-size-6"
                    v-if="tvaAmount">
                    ({{ tvaAmount | prettyPrice }} €)
                  </div>
                </div>
                <div class="column">
                  <r-label
                    v-if="errors.has('sale_price_ttc')"
                    :red-check="true"
                    :label="`Prix immo TTC`"></r-label>
                  <r-label
                    v-else
                    :label="`Prix immo TTC`"
                    :value="sale.sale_price_ttc"></r-label>
                  <div class="field has-addons">
                    <p class="control is-expanded">
                      <v-input
                        id="sale_price_ttc"
                        :name="'sale_price_ttc'"
                        @input="val => updateSalePrice(val)"
                        :model="sale.sale_price_ttc"
                        :number="true"
                        input-type="number"
                        :errors-bag="errors"
                        data-vv-value-path="val"
                        classes="has-text-right"
                        data-vv-as=" "
                        v-validate="'required|decimal:2'">
                      </v-input>
                    </p>
                    <div class="control">
                      <a class="button is-static is-border is-square"><b class="">€&nbsp;TTC</b></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="parkings && parkings.length"
              class="is-padding-left-small is-padding-right is-padding-top-xsmall has-background-white is-padding-bottom-xsmall is-minH50p is-flex is-border-top">
              <div class="is-self-centered">
                <span class="is-uppercase title is-6">Dont prix {{ parkings.length > 1 ? 'des stationnements' : 'du stationnement' }}</span>
              </div>
            </div>
            <template>
              <div
                v-for="(parking, idx) in parkings"
                :key="idx"
                class="is-border-top has-background-white is-padding-left is-padding-right ">
                <div class="columns is-gapless is-vcentered is-minH50p">
                  <div class="column is-padding-right">
                    <span>
                      <b class="is-size-6">{{ parking.nature | lotTypeLabel }} :</b>&nbsp;
                      <span
                        class="is-size-6"
                        v-for="(type, i ) in parking.parking_type"
                        :key="'type' + i">{{ i > 0 ? ', ' : '' }}{{ type | lotSubtypeLabel }}</span>&nbsp;
                      <span
                        class="is-size-6"
                        v-if="parking.info">({{ parking.info }})</span>&nbsp;
                      <span
                        class="is-size-6"
                        v-for="(sale_mode, i ) in parking.sales_mode"
                        :key="'sale_mode' + i">{{ i > 0 ? ', ' : '' }}{{ sale_mode | salesmodeLabel }}</span>
                      <span v-if="parking.sale_price_ttc"> - {{ parking.sale_price_ttc }} €</span>
                    </span>
                  </div>
                  <div class="column is-narrow">
                    <div class="field">
                      <input
                        type="checkbox"
                        :id="'check_parking' + idx"
                        :value="'check_parking' + idx"
                        v-model="checkParking[parking.pk]"
                        @change="initParking"
                        class="switch is-rounded is-success">
                      <label :for="'check_parking' + idx">&nbsp;</label>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="is-padding-left-small is-padding-right is-padding-top-xsmall has-background-white is-padding-bottom-xsmall is-minH50p is-flex is-border-top is-border-bottom">
              <div class="is-self-centered">
                <span class="is-uppercase title is-6">Date de signature</span>
              </div>
            </div>
            <div class="is-padding">
              <div class="columns is-marginless-bottom">
                <div class="column is-6">
                  <date-picker
                    :model="sale.signature_date"
                    @input="sale.signature_date = $event"
                    class="is-self-centered"
                    :red-check="error.signature_date"
                    :field-class="'is-margin-left-xxsmall is-margin-right-xsmall is-self-centered'"
                    :input-class="'is-fullwidth'"
                    :style-version="2"
                    :is-required="true"
                    label="Date de signature du contrat de réservation"></date-picker>
                </div>
                <div class="column is-6">
                  <date-picker
                    :model="sale.sale_date"
                    @input="sale.sale_date = $event"
                    class="is-self-centered"
                    :field-class="'is-margin-left-xxsmall is-margin-right-xsmall is-self-centered'"
                    :input-class="'is-fullwidth'"
                    :style-version="2"
                    label="Date de signature de l'acte"></date-picker>
                </div>
              </div>
            </div>
            <div>
              <div class="is-padding-left has-background-white is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-minH50p is-flex is-border-top">
                <div class="is-self-centered">
                  <span class="is-uppercase title is-6">Commentaire(s)</span>
                </div>
              </div>
              <div
                class="field is-border-top has-background-white is-padding-xsmall"
                @mouseover="displayToolbar = true"
                @mouseleave="displayToolbar = false">
                <div class="control">
                  <wysiwyg-editor
                    :model="sale.comment"
                    placeholder=""
                    id="descText"
                    name="descText"
                    @change="val => sale.comment = val"
                    :light-program="true"
                    :light="true"
                    :tooltip-top="true"
                    :class="{'editr--hide-toolbar':!displayToolbar}"
                    class="editr--bottom-toolbar editr--height-medium content"
                    data-type-cy="wysiwyg-editor"
                    data-value-cy="input_desc" />
                </div>
              </div>
            </div>
          </div>
          <submit-sticky-buttons
            @submit="submit"
            button-id="saleForm"
            :loading="submitLoading"></submit-sticky-buttons>
        </form>
      </div>
    </page-content>
  </div>
</template>

<script>
import { DefaultValues, Quickview } from '@/mixins'
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'

const emptySale = ({
  lot: null,
  buyers: null,
  account: null,
  user: null,
  seller_data: null,
  sale_date: null,
  parkings: [],
  signature_date: null,
  destination: null,
  tax_dispositif: null,
  sale_price_ht: null,
  sale_price_ttc: null,
  tva: null,
  pack: null,
  remuneration: null,
  seller_remuneration: null,
  comment: null
})

export default {
  name: 'SaleForm',
  components: {
    AdvLotCompact: () => import('../adv/AdvLotCompact')
  },
  mixins: [DefaultValues, Quickview],
  data () {
    return {
      initialTva: null,
      displayToolbar: false,
      checkParking: {},
      tvaAmount: null,
      packList: [],
      selectedPack: null,
      program: null,
      error: {
        seller_remuneration: false,
        signature_date: false,
        contact: false,
        seller: false,
        destination: false,
        tax: false
      },
      parkings: [],
      sale: null,
      contact: null,
      isDisabled: false,
      seller: null,
      submitLoading: false,
      loading: false,
      lot: null,
      contactsCount: null,
      sellersCount: null,
      sellersExternalCount: null
    }
  },
  computed: {
    ...mapState(['currentUser', 'quickview']),
    lotPk () {
      return this.$route.params.id
    },
    availableDispositifs () {
      return this.taxDispositifsList
    },
    hasContact () {
      if (this.contact) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    quickview ({ mode, params, results }) {
      if (results && mode === 'USER_SELECTION') {
        if (results.entities.length) {
          this.seller = Object.assign({}, results.entities[0])
          this.sale.user = this.seller.pk
          this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        } else {
          this.$toasted.global.danger('Veuillez sélectionner un utilisateur')
        }
      } else if (results && mode === 'USER_CREATE') {
        this.createUser(results.user)
      } else if (mode === 'CONTACT_SELECTION' && results) {
        if (results.entities.length) {
          this.addContact(results.entities[0])
        } else {
          this.$toasted.global.danger('Veuillez sélectionner un contact')
        }
      } else if (mode === 'CONTACT_CREATE' && results) {
        this.createContact(results.contact)
      } else if (mode === 'RELATION_SELECTION' && results) {
        if (results.entities.length) {
          this.seller = Object.assign({}, results.entities[0])
          this.sale.account = this.seller.pk
          this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        } else {
          this.$toasted.global.danger('Veuillez sélectionner une société')
        }
      }
    },
    'seller' (v) {
      if (v === null) {
        this.error.seller = true
      } else {
        this.error.seller = false
      }
    },
    'contact' (v) {
      if (v === null) {
        this.error.contact = true
      } else {
        this.error.contact = false
      }
    },
    'sale.seller_remuneration' (v) {
      this.error.seller_remuneration = false
    },
    'sale.destination' (v) {
      this.error.destination = false
    },
    'sale.tax_dispositif' (v) {
      this.error.tax = false
    },
    'sale.signature_date' (v) {
      this.error.signature_date = false
    }
  },
  async created () {
    this.sale = Object.assign({}, emptySale)
    this.sale.lot = this.lotPk
    await this.getLot()
    this.initialTva = this.sale.tva
    await this.getPackList()
    await this.getContactsCount()
    await this.getSellersCount()
    await this.getSellersExternal()
    this.sale.remuneration = this.program.remuneration || 0
  },
  methods: {
    async addContact (contact) {
      let completeContact = await this.returnContact(contact.pk)
      this.contact = Object.assign({}, completeContact)
      if (!this.sale.buyers) {
        this.sale.buyers = [completeContact]
      } else {
        this.sale.buyers.push(completeContact)
      }
      this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
    },
    async returnContact (id) {
      try {
        let { data } = await this.$api.getOne(this.$resources.CONTACT, id)
        return data
      } catch (err) {
        console.log(err)
      }
    },
    resetSeller () {
      this.seller = null
      this.sale.user = null
      this.sale.account = null
      this.sale.seller_data = null
      this.getSellersCount()
      this.getSellersExternal()
    },
    initParking () {
      let selectedParkings = []
      for (let parking in this.checkParking) {
        if (this.checkParking[parking]) {
          let filteredParking = this.parkings.filter(x => x.pk === parking)
          selectedParkings.push(filteredParking[0])
        }
      }
      this.sale.parkings = selectedParkings
    },
    updateSalePrice: debounce(function (valSalePrice) {
      let salePriceTTC, salePriceHT
      if (!this.sale.sale_price_ttc || Number(valSalePrice) !== Number(this.sale.sale_price_ttc)) {
        salePriceTTC = valSalePrice
        salePriceHT = salePriceTTC / (1 + (this.sale.tva / 100))
        salePriceHT = salePriceHT.toFixed(2)
      }
      this.updatePrice(salePriceTTC, salePriceHT)
    }, 500),
    updateSalePriceHt: debounce(function (valSalePriceHt) {
      let salePriceTTC, salePriceHT
      if (!this.sale.sale_price_ht || Number(valSalePriceHt) !== Number(this.sale.sale_price_ht)) {
        salePriceHT = valSalePriceHt
        salePriceTTC = salePriceHT * (1 + (this.sale.tva / 100))
        salePriceTTC = salePriceTTC.toFixed(2)
      }
      this.updatePrice(salePriceTTC, salePriceHT)
    }, 500),
    updatePrice (salePriceTTC, salePriceHT) {
      if (salePriceTTC) this.$set(this.sale, 'sale_price_ttc', salePriceTTC)
      if (salePriceHT) this.$set(this.sale, 'sale_price_ht', salePriceHT)
      this.$set(this, 'tvaAmount', Number(this.sale.sale_price_ttc) - Number(this.sale.sale_price_ht))
    },
    updateTva (val) {
      if (val) this.$set(this.sale, 'tva', val)
      let tva = this.sale.tva

      let salePriceTTC = Number(this.sale.sale_price_ttc)
      let salePriceHT = Number(this.sale.sale_price_ht)
      salePriceTTC = salePriceHT * (1 + (tva / 100))
      salePriceTTC = salePriceTTC.toFixed(2)
      this.updatePrice(salePriceTTC, salePriceHT)
    },
    async getPackList () {
      this.loading = true
      try {
        let request = await this.$api.axios.get(`lots/${this.lot.pk}/packs`)
        this.packList = request.data.items
        this.loading = false
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    },
    async createContact (contact) {
      let contactUser = null
      if (contact.user) {
        contactUser = contact.user.pk
      } else {
        contactUser = this.currentUser.pk
      }
      let payload = {
        contact: this.$cleanPayload(contact),
        user: contactUser
      }
      let { data } = await this.$api.post(this.$resources.CONTACT_CHECK, payload)
      if (data.duplicates.length !== 0 || data.all_pk_contact.length !== 0) {
        data.duplicates.length !== 0 ? contact.doublon_denunciation = true : contact.doublon_denunciation = false
        data.all_pk_contact.length !== 0 ? contact.doublon_contact = true : contact.doublon_contact = false
      }
      this.$store.commit('setQuickviewLoading', true)
      try {
        let { data } = await this.$api.post(this.$resources.CONTACT, this.$cleanPayload(contact))
        data = data.json_data
        this.contact = data
        if (!this.sale.buyers) {
          this.sale.buyers = [data]
        } else {
          this.sale.buyers.push(data)
        }
        this.loading = false
        this.$toasted.global.success('Contact ajouté')
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        this.$store.commit('setQuickviewLoading', false)
      } catch (e) {
        console.log(e)
        this.loading = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
        this.$store.commit('setQuickviewLoading', false)
      }
    },
    async createUser (user) {
      this.sale.seller_data = Object.assign({}, user)
      this.seller = Object.assign({}, user)
      this.$toasted.global.success('Utilisateur ajouté')
      this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
    },
    async getSellersCount () {
      let query = {
        per_page: 1
      }
      const { data } = await this.$api.get(this.$resources.USER, query)
      this.sellersCount = data.count
    },
    async getSellersExternal () {
      let query = {
        per_page: 1
      }
      const { data } = await this.$api.get(this.$resources.ACCOUNT_RELATION, query)
      this.sellersExternalCount = data.count
    },
    async getContactsCount () {
      let query = {
        per_page: 1
      }
      if (this.seller) {
        query.user = this.seller.pk
      }
      const { data } = await this.$api.get(this.$resources.CONTACT, query)
      this.contactsCount = data.count
    },
    openSellerSelection (type = 'multiple') {
      let params = {
        facets: {
          USER: [
            [`profil:seller`, `profil:manager`, `profil:admin`]
          ]
        },
        selectType: type,
        mode: 'store'
      }
      this.openUserSelectionQuickview(params)
    },
    openRelationSelection (type = 'multiple') {
      let params = {
        facets: {
          ACCOUNT: []
        },
        selectType: type,
        searchKeys: 'ACCOUNT',
        mode: 'store'
      }
      this.openRelationSelectionQuickview(params)
    },
    openContactSelection (type = 'multiple') {
      let params = {
        mode: 'store',
        facets: {
          CONTACT: []
        },
        selectType: type
      }
      this.openContactSelectionQuickview({ params })
    },
    async getLot () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.LOT, this.lotPk)
        this.lot = data
        this.sale.sale_price_ht = this.lot.sale_price_ht
        this.sale.sale_price_ttc = this.lot.sale_price_ttc
        this.sale.tva = Number((this.lot.sale_price_ttc - this.lot.sale_price_ht) * 100 / this.lot.sale_price_ht).toFixed(2)
        this.parkings = data.parkings
        let newReservationParkings = []
        for (let parking of this.parkings) {
          this.checkParking[parking.pk] = true
          newReservationParkings.push(parking)
        }
        this.sale.parkings = newReservationParkings
        this.getProgram(data.program.pk)
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    async getProgram (id) {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.PROGRAM, id)
        this.program = data
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    async submit () {
      this.submitLoading = true
      let sale = Object.assign({}, this.sale)
      if (this.selectedPack) {
        sale.pack = this.selectedPack.pk
      } else {
        sale.pack = null
      }
      if (!sale.user && !sale.account && !sale.seller_data) {
        this.submitLoading = false
        this.error.seller = true
      }
      if (!sale.buyers || !sale.buyers.length) {
        this.submitLoading = false
        this.error.contact = true
      }
      if (!sale.destination) {
        this.error.destination = true
        this.submitLoading = false
      }
      if (sale.destination && sale.destination === 'invest' && !sale.tax_dispositif) {
        this.error.tax = true
        this.submitLoading = false
      }
      if (!sale.seller_remuneration) {
        this.error.seller_remuneration = true
        this.submitLoading = false
      }
      if (!sale.signature_date) {
        this.error.signature_date = true
        this.submitLoading = false
      }
      const formIsValid = await this.$validator.validateAll()
      if (this.error.signature_date || this.error.tax || this.error.contact || this.error.destination || this.error.seller || !formIsValid) {
        this.$toasted.global.danger('Oups ! Merci de renseigner le ou les champs obligatoires.')
        this.submitLoading = false
        return
      }
      sale.signature_date = moment(sale.signature_date).hours(12).toISOString()
      if (sale.sale_date) {
        sale.sale_date = moment(sale.sale_date).hours(12).toISOString()
      }
      try {
        let { data } = await this.$api.post(this.$resources.RESERVATION, sale)
        this.$router.replace({ name: 'AdvInfos', params: { id: data.pk } })
      } catch (err) {
        console.log(err)
        this.$toasted.global.danger('Erreur lors de la validation du formulaire')
      } finally {
        this.submitLoading = false
      }
    }
  }
}
</script>
